/**
 * External dependencies
 */
import {
	// createResponsiveStyles,
	// __getValue,
} from '~cartzillagb/util'
import deepmerge from 'deepmerge'

/**
 * Internal dependencies
 */

export const createStyles = () => {
	const styles = []

	return deepmerge.all( styles )
}

export default createStyles
